module.exports = __webpack_public_path__ + "img/membership.be8976d8.png";